import { Routes } from '@angular/router';
import { AuthComponent } from './auth/pages/auth/auth.component';
import { AuthGuard } from './auth-guard.service';
import { SenhaRecuperarComponent } from './auth/pages/senha-recuperar/senha-recuperar.component';
import { SenhaAlterarComponent } from './auth/pages/senha-alterar/senha-alterar.component';
import { PortalCotacaoComponent } from './portal/cotacao/portal-cotacao.component';
import { PortalPedidoComponent } from './portal/pedido/portal-pedido.component';
import { PortalVendaComponent } from './portal/venda/portal-venda.component';
import { HomeComponent } from './home/pages/home/home.component';
import { ConfiguracoesHomeComponent } from './configuracoes/pages/configuracoes-home/configuracoes-home.component';
import { UsuarioListaComponent } from './configuracoes/pages/usuario-lista/usuario-lista.component';
import { UsuarioCadastroComponent } from './configuracoes/pages/usuario-cadastro/usuario-cadastro.component';
import { PerfilListaComponent } from './configuracoes/pages/perfil-lista/perfil-lista.component';
import { PerfilCadastroComponent } from './configuracoes/pages/perfil-cadastro/perfil-cadastro.component';
import { EmpresaCadastroComponent } from './configuracoes/pages/empresa/empresa-cadastro.component';
import { ModuloEnum } from './shared/enums/usuario/modulo.enum';
import { WhatsappCadastroComponent } from './home/pages/ferramentas/pages/whatsapp-cadastro/whatsapp-cadastro.component';
import { IntegracaoHomeComponent } from './integration/pages/integracao-home/integracao-home.component';
import { ChaveAcessoListaComponent } from './integration/pages/chave-acesso-lista/chave-acesso-lista.component';
import { ChaveAcessoCadastroComponent } from './integration/pages/chave-acesso-cadastro/chave-acesso-cadastro.component';
import { LogIntegracaoListaComponent } from './integration/pages/log-integracao-lista/log-integracao-lista.component';
import { LogIntegracaoDetalhesComponent } from './integration/pages/log-integracao-detalhe/log-integracao-detalhe.component';
import { IntegracaoZoppyComponent } from './integration/pages/integracao-zoppy/integracao-zoppy.component';
import { ResulthLocalConnectComponent } from './integration/pages/resulth-local-connect/resulth-local-connect.component';
import { NotasFiscaisHomeComponent } from './notas-fiscais/pages/notas-fiscais-home/notas-fiscais-home.component';
import { PainelContadorComponent } from './notas-fiscais/pages/painel-contador/painel-contador.component';
import { DetalheNFeEmitidoComponent } from './notas-fiscais/pages/painel-contador/detalhe-nfe-emitido/detalhe-nfe-emitido.component';
import { DetalheNFCeEmitidoComponent } from './notas-fiscais/pages/painel-contador/detalhe-nfce-emitido/detalhe-nfce-emitido.component';
import { DetalheNFSeEmitidoComponent } from './notas-fiscais/pages/painel-contador/detalhe-nfse-emitido/detalhe-nfse-emitido.component';
import { DetalheNFeRecebidoComponent } from './notas-fiscais/pages/painel-nota-recebida/detalhe-nfe-recebido/detalhe-nfe-recebido.component';
import { DetalheCTeRecebidoComponent } from './notas-fiscais/pages/painel-nota-recebida/detalhe-cte-recebido/detalhe-cte-recebido.component';
import { ConfigurarResulthScanntechComponent } from './integration/pages/resulth-scanntech/configurar-resulth-scanntech/configurar-resulth-scanntech.component';
import { ResulthScanntechListaComponent } from './integration/pages/resulth-scanntech/resulth-scanntech-lista/resulth-scanntech-lista.component';
import { RelatorioVendasResulthScanntechComponent } from './integration/pages/resulth-scanntech/relatorio-vendas-resulth-scanntech/relatorio-vendas-resulth-scanntech.component';
import { DadosIntegracaoScanntechComponent } from './integration/pages/resulth-scanntech/dados-integracao-scanntech/dados-integracao-scanntech.component';
import { PainelNotaRecebidaComponent } from './notas-fiscais/pages/painel-nota-recebida/painel-nota-recebida.component';
import { NFCesEmContingenciaComponent } from './home/pages/nfces-em-contingencia/nfces-em-contingencia.component';
import { CadastrosHomeComponent } from './cadastros/pages/cadastros-home/cadastros-home.component';
import { VendedorListaComponent } from './cadastros/pages/vendedor-lista/vendedor-lista.component';
import { VendedorCadastroComponent } from './cadastros/pages/vendedor-cadastro/vendedor-cadastro.component';
import { ConfigCadastrosComponent } from './configuracoes/pages/config-cadastros/config-cadastros.component';
import { ConfigFinancasComponent } from './configuracoes/pages/config-financas/config-financas.component';
import { PessoaListaComponent } from './cadastros/pages/pessoa-lista/pessoa-lista.component';
import { PessoaCadastroComponent } from './cadastros/pages/pessoa-cadastro/pessoa-cadastro.component';
import { ConfigPessoaComponent } from './configuracoes/pages/config-cadastros/config-pessoa/config-pessoa.component';
import { ConfigProdutoComponent } from './configuracoes/pages/config-cadastros/config-produto/config-produto.component';
import { ProdutoListaComponent } from './cadastros/pages/produto-lista/produto-lista.component';
import { ProdutoCadastroComponent } from './cadastros/pages/produto-cadastro/produto-cadastro.component';
import { ConfigTagsComponent } from './configuracoes/pages/config-cadastros/config-tags/config-tags.component';
import { TagCadastroComponent } from './configuracoes/pages/config-cadastros/tag-cadastro/tag-cadastro.component';
import { ConfigMarcasComponent } from './configuracoes/pages/config-cadastros/config-marcas/config-marcas.component';
import { MarcaCadastroComponent } from './configuracoes/pages/config-cadastros/marca-cadastro/marca-cadastro.component';
import { ConfigUnidadesMedidaComponent } from './configuracoes/pages/config-cadastros/config-unidades-medida/config-unidades-medida.component';
import { UnidadeMedidaCadastroComponent } from './configuracoes/pages/config-cadastros/unidade-medida-cadastro/unidade-medida-cadastro.component';
import { ConfigVariacoesComponent } from './configuracoes/pages/config-cadastros/config-variacoes/config-variacoes.component';
import { VariacaoCadastroComponent } from './configuracoes/pages/config-cadastros/variacao-cadastro/variacao-cadastro.component';
import { ConfigAtributosProdutosComponent } from './configuracoes/pages/config-cadastros/config-atributos-produtos/config-atributos-produtos.component';
import { AtributoCadastroComponent } from './configuracoes/pages/config-cadastros/atributo-cadastro/atributo-cadastro.component';
import { FerramentasComponent } from './home/pages/ferramentas/ferramentas.component';
import { MinhasExportacoesComponent } from './home/pages/ferramentas/pages/minhas-exportacoes/minhas-exportacoes.component';
import { AutomacaoExtracaoDadosListaComponent } from './home/pages/ferramentas/pages/automacao-extracao-dados-lista/automacao-extracao-dados-lista.component';
import { AutomacaoExtracaoDadosCadastroComponent } from './home/pages/ferramentas/pages/automacao-extracao-dados-cadastro/automacao-extracao-dados-cadastro.component';
import { EmbalagemListaComponent } from './cadastros/pages/embalagem-lista/embalagem-lista.component';
import { CategoriaListaComponent } from './cadastros/pages/categoria-lista/categoria-lista.component';
import { CategoriaCadastroComponent } from './cadastros/pages/categoria-cadastro/categoria-cadastro.component';
import { EmbalagemCadastroComponent } from './cadastros/pages/embalagem-cadastro/embalagem-cadastro.component';
import { ServicoListaComponent } from './cadastros/pages/servico-lista/servico-lista.component';
import { ServicoCadastroComponent } from './cadastros/pages/servico-cadastro/servico-cadastro.component';
import { ConfigListaPrecoComponent } from './configuracoes/pages/config-cadastros/config-lista-preco/config-lista-preco.component';
import { ListaPrecoCadastroComponent } from './configuracoes/pages/config-cadastros/lista-preco-cadastro/lista-preco-cadastro.component';
import { ConfigNotasFiscaisComponent } from './configuracoes/pages/config-notas-fiscais/config-notas-fiscais.component';
import { BuscaNFeSefazComponent } from './configuracoes/pages/config-notas-fiscais/busca-nfe-sefaz/busca-nfe-sefaz.component';
import { ConfigNFCeComponent } from './configuracoes/pages/config-notas-fiscais/config-nfce/config-nfce.component';
import { ConfigGeralNotasFiscaisComponent } from './configuracoes/pages/config-notas-fiscais/config-geral-notas-fiscais/config-geral-notas-fiscais.component';
import { ConfigNFeComponent } from './configuracoes/pages/config-notas-fiscais/config-nfe/config-nfe.component';
import { ConfigLinhaProdutosComponent } from './configuracoes/pages/config-cadastros/config-linha-produtos/config-linha-produtos.component';
import { LinhaProdutoCadastroComponent } from './configuracoes/pages/config-cadastros/linha-produto-cadastro/linha-produto-cadastro.component';
import { FormasPagamentoComponent } from './configuracoes/pages/config-financas/formas-pagamento/formas-pagamento.component';
import { IntermediadorPagamentoComponent } from './configuracoes/pages/config-financas/intermediador-pagamento/intermediador-pagamento.component';
import { IntermediadorPagamentoCadastroComponent } from './configuracoes/pages/config-financas/intermediador-pagamento-cadastro/intermediador-pagamento-cadastro.component';
import { FormasRecebimentoListComponent } from './configuracoes/pages/config-financas/formas-recebimento-list/formas-recebimento-list.component';
import { FormaRecebimentoCadastroComponent } from './configuracoes/pages/config-financas/forma-recebimento-cadastro/forma-recebimento-cadastro.component';
import { CondicoesPagamentoListComponent } from './configuracoes/pages/config-financas/condicoes-pagamento-list/condicoes-pagamento-list.component';
import { CondicaoPagamentoCadastroComponent } from './configuracoes/pages/config-financas/condicao-pagamento-cadastro/condicao-pagamento-cadastro.component';
import { TagsMovimentacaoComponent } from './configuracoes/pages/config-financas/tags-movimentacao/tags-movimentacao.component';
import { TagsContasPagarComponent } from './configuracoes/pages/config-financas/tags-contas-pagar/tags-contas-pagar.component';
import { TagsContasReceberComponent } from './configuracoes/pages/config-financas/tags-contas-receber/tags-contas-receber.component';
import { TagMovimentacaoCadastroComponent } from './configuracoes/pages/config-financas/tag-movimentacao-cadastro/tag-movimentacao-cadastro.component';
import { TagContasPagarCadastroComponent } from './configuracoes/pages/config-financas/tag-contas-pagar-cadastro/tag-contas-pagar-cadastro.component';
import { TagContasReceberCadastroComponent } from './configuracoes/pages/config-financas/tag-contas-receber-cadastro/tag-contas-receber-cadastro.component';
import { CentrosCustoComponent } from './configuracoes/pages/config-financas/centros-custo/centros-custo.component';
import { CentroCustoCadastroComponent } from './configuracoes/pages/config-financas/centro-custo-cadastro/centro-custo-cadastro.component';
import { RateiosCentroCustoComponent } from './configuracoes/pages/config-financas/rateios-centro-custo/rateios-centro-custo.component';
import { RateioCentroCustoCadastroComponent } from './configuracoes/pages/config-financas/rateio-centro-custo-cadastro/rateio-centro-custo-cadastro.component';
import { ConfigContasPagarComponent } from './configuracoes/pages/config-financas/config-contas-pagar/config-contas-pagar.component';
import { ConfigContasReceberComponent } from './configuracoes/pages/config-financas/config-contas-receber/config-contas-receber.component';
import { ConfigGeralFinancasComponent } from './configuracoes/pages/config-financas/config-geral-financas/config-geral-financas.component';
import { CategoriaFinanceiraListaComponent } from './configuracoes/pages/config-financas/categoria-financeira-lista/categoria-financeira-lista.component';
import { CategoriaFinanceiraCadastroComponent } from './configuracoes/pages/config-financas/categoria-financeira-cadastro/categoria-financeira-cadastro.component';
import { ConfigCategoriaFinanceiraPadraoComponent } from './configuracoes/pages/config-financas/config-categoria-financeira-padrao/config-categoria-financeira-padrao.component';
import { CamposObrigatoriosCadastrosComponent } from './configuracoes/pages/config-cadastros/campos-obrigatorios/campos-obrigatorios-cadastros.component';
import { CamposObrigatoriosFinancasComponent } from './configuracoes/pages/config-financas/campos-obrigatorios/campos-obrigatorios-financas.component';
import { ConfigVendasComponent } from './configuracoes/pages/config-vendas/config-vendas.component';
import { ConfigGeralVendasComponent } from './configuracoes/pages/config-vendas/config-geral-vendas/config-geral-vendas.component';
import { ConfigPdvComponent } from './configuracoes/pages/config-vendas/config-pdv/config-pdv.component';
import { ConfigOrcamentoComponent } from './configuracoes/pages/config-vendas/config-orcamento/config-orcamento.component';
import { ConfigPedidoVendaComponent } from './configuracoes/pages/config-vendas/config-pedido-venda/config-pedido-venda.component';
import { ConfigSeparacaoComponent } from './configuracoes/pages/config-vendas/config-separacao/config-separacao.component';
import { ConfigExpedicaoComponent } from './configuracoes/pages/config-vendas/config-expedicao/config-expedicao.component';
import { ConfigKanbanComponent } from './configuracoes/pages/config-vendas/config-kanban/config-kanban.component';
import { ConfigKanbanOportunidadesComponent } from './configuracoes/pages/config-vendas/config-kanban-oportunidades/config-kanban-oportunidades.component';
import { MotivosTransicaoComponent } from './configuracoes/pages/config-vendas/motivos-transicao/motivos-transicao.component';
import { MotivoTransicaoCadastroComponent } from './configuracoes/pages/config-vendas/motivo-transicao-cadastro/motivo-transicao-cadastro.component';
import { TagsVendaComponent } from './configuracoes/pages/config-vendas/tags-venda/tags-venda.component';
import { FormasEnvioComponent } from './configuracoes/pages/config-vendas/formas-envio/formas-envio.component';
import { FormaEnvioCadastroComponent } from './configuracoes/pages/config-vendas/forma-envio-cadastro/forma-envio-cadastro.component';
import { TagVendaCadastroComponent } from './configuracoes/pages/config-vendas/tag-venda-cadastro/tag-venda-cadastro.component';
import { TagsNFeSaidaComponent } from './configuracoes/pages/config-vendas/tags-nfe-saida/tags-nfe-saida.component';
import { TagNFeSaidaCadastroComponent } from './configuracoes/pages/config-vendas/tag-nfe-saida-cadastro/tag-nfe-saida-cadastro.component';
import { TagsCrmComponent } from './configuracoes/pages/config-vendas/tags-crm/tags-crm.component';
import { TagCrmCadastroComponent } from './configuracoes/pages/config-vendas/tag-crm-cadastro/tag-crm-cadastro.component';
import { TagsDevolucaoVendaComponent } from './configuracoes/pages/config-vendas/tags-devolucao-venda/tags-devolucao-venda.component';
import { TagDevolucaoVendaCadastroComponent } from './configuracoes/pages/config-vendas/tag-devolucao-venda-cadastro/tag-devolucao-venda-cadastro.component';
import { TagsSeparacaoComponent } from './configuracoes/pages/config-vendas/tags-separacao/tags-separacao.component';
import { TagSeparacaoCadastroComponent } from './configuracoes/pages/config-vendas/tag-separacao-cadastro/tag-separacao-cadastro.component';
import { DevolucoesVendaComponent } from './configuracoes/pages/config-vendas/devolucoes-venda/devolucoes-venda.component';
import { AutomacoesVendaComponent } from './configuracoes/pages/config-vendas/automacoes-venda/automacoes-venda.component';
import { ConfigServicosComponent } from './configuracoes/pages/config-servicos/config-servicos.component';
import { TagsOrdemServicoComponent } from './configuracoes/pages/config-servicos/tags-ordem-servico/tags-ordem-servico.component';
import { TagOrdemServicoCadastroComponent } from './configuracoes/pages/config-servicos/tag-ordem-servico-cadastro/tag-ordem-servico-cadastro.component';
import { TagsContratoComponent } from './configuracoes/pages/config-servicos/tags-contrato/tags-contrato.component';
import { TagContratoCadastroComponent } from './configuracoes/pages/config-servicos/tag-contrato-cadastro/tag-contrato-cadastro.component';
import { CnaesComponent } from './configuracoes/pages/config-servicos/cnaes/cnaes.component';
import { CnaeCadastroComponent } from './configuracoes/pages/config-servicos/cnae-cadastro/cnae-cadastro.component';
import { CamposAdicionaisComponent } from './configuracoes/pages/config-servicos/campos-adicionais/campos-adicionais.component';
import { CampoAdicionalCadastroComponent } from './configuracoes/pages/config-servicos/campo-adicional-cadastro/campo-adicional-cadastro.component';
import { EnvioDocumentosServicoComponent } from './configuracoes/pages/config-servicos/envio-documentos-servico/envio-documentos-servico.component';
import { ConfigGeralOrdemServicoComponent } from './configuracoes/pages/config-servicos/config-geral-ordem-servico/config-geral-ordem-servico.component';
import { ConfigKanbanOrdemServicoComponent } from './configuracoes/pages/config-servicos/config-kanban-ordem-servico/config-kanban-ordem-servico.component';
import { AutomacoesOrdemServicoComponent } from './configuracoes/pages/config-servicos/automacoes-ordem-servico/automacoes-ordem-servico.component';
import { MotivosTransicaoOrdemServicoComponent } from './configuracoes/pages/config-servicos/motivos-transicao-ordem-servico/motivos-transicao-ordem-servico.component';
import { MotivoTransicaoOrdemServicoCadastroComponent } from './configuracoes/pages/config-servicos/motivo-transicao-ordem-servico-cadastro/motivo-transicao-ordem-servico-cadastro.component';
import { ExtratoMovimentacoesComponent } from './financas/pages/extrato-movimentacoes/extrato-movimentacoes.component';
import { ConciliacaoBancariaContasComponent } from './financas/pages/conciliacao-bancaria-contas/conciliacao-bancaria-contas.component';
import { ConciliacaoBancariaLancamentosComponent } from './financas/pages/conciliacao-bancaria-lancamentos/conciliacao-bancaria-lancamentos.component';
import { ConciliacaoBancariaIgnoradosComponent } from './financas/pages/conciliacao-bancaria-ignorados/conciliacao-bancaria-ignorados.component';
import { ConciliacaoBancariaConciliadosComponent } from './financas/pages/conciliacao-bancaria-conciliados/conciliacao-bancaria-conciliados.component';
import { ConciliacaoCartaoLancamentosComponent } from './financas/pages/conciliacao-cartao-lancamentos/conciliacao-cartao-lancamentos.component';
import { ConciliacaoCartaoConciliadosComponent } from './financas/pages/conciliacao-cartao-conciliados/conciliacao-cartao-conciliados.component';
import { LancamentoCadastroComponent } from './financas/pages/lancamento-cadastro/lancamento-cadastro.component';
import { TransferenciaCadastroComponent } from './financas/pages/transferencia-cadastro/transferencia-cadastro.component';
import { FinancasHomeComponent } from './financas/pages/financas-home/financas-home.component';
import { RelatoriosFinancasComponent } from './financas/pages/relatorios-financas/relatorios-financas.component';
import { RelatorioEntradasSaidasClienteComponent } from './financas/pages/relatorios-financas/relatorio-entradas-saidas-cliente/relatorio-entradas-saidas-cliente.component';
import { RelatorioEntradasSaidasCategoriaComponent } from './financas/pages/relatorios-financas/relatorio-entradas-saidas-categoria/relatorio-entradas-saidas-categoria.component';
import { RelatorioContasPagarComponent } from './financas/pages/relatorios-financas/relatorio-contas-pagar/relatorio-contas-pagar.component';
import { RelatorioContasReceberComponent } from './financas/pages/relatorios-financas/relatorio-contas-receber/relatorio-contas-receber.component';
import { RelatorioFluxoCaixaComponent } from './financas/pages/relatorios-financas/relatorio-fluxo-caixa/relatorio-fluxo-caixa.component';
import { ContasPagarListaComponent } from './financas/pages/contas-pagar-lista/contas-pagar-lista.component';
import { ContasPagarCadastroComponent } from './financas/pages/contas-pagar-cadastro/contas-pagar-cadastro.component';
import { ContasPagarParcelaCadastroComponent } from './financas/pages/contas-pagar-parcela-cadastro/contas-pagar-parcela-cadastro.component';
import { ContasReceberListaComponent } from './financas/pages/contas-receber-lista/contas-receber-lista.component';
import { ContasReceberCadastroComponent } from './financas/pages/contas-receber-cadastro/contas-receber-cadastro.component';
import { ContasReceberParcelaCadastroComponent } from './financas/pages/contas-receber-parcela-cadastro/contas-receber-parcela-cadastro.component';
import { CertificadoECNPJComponent } from './configuracoes/pages/config-notas-fiscais/certificado-e-cnpj/certificado-e-cnpj.component';
import { EmissorListaComponent } from './configuracoes/pages/config-notas-fiscais/emissor-lista/emissor-lista.component';
import { EmissorCadastroComponent } from './configuracoes/pages/config-notas-fiscais/emissor-cadastro/emissor-cadastro.component';
import { TabelaAnpComponent } from './configuracoes/pages/config-notas-fiscais/tabela-anp/tabela-anp.component';
import { ConfigSuprimentosComponent } from './configuracoes/pages/config-suprimentos/config-suprimentos.component';
import { FormulasCustoVendaComponent } from './configuracoes/pages/config-suprimentos/formulas-custo-venda/formulas-custo-venda.component';
import { ConfigEstoqueComponent } from './configuracoes/pages/config-suprimentos/config-estoque/config-estoque.component';
import { ConfigFciComponent } from './configuracoes/pages/config-suprimentos/config-fci/config-fci.component';
import { ConfigKanbanComprasComponent } from './configuracoes/pages/config-suprimentos/config-kanban-compras/config-kanban-compras.component';
import { AutomacoesComprasComponent } from './configuracoes/pages/config-suprimentos/automacoes-compras/automacoes-compras.component';
import { ComunicacaoCotacaoComponent } from './configuracoes/pages/config-suprimentos/comunicacao-cotacao/comunicacao-cotacao.component';
import { ComunicacaoPedidoComponent } from './configuracoes/pages/config-suprimentos/comunicacao-pedido/comunicacao-pedido.component';
import { TagsCompraComponent } from './configuracoes/pages/config-suprimentos/tags-compra/tags-compra.component';
import { TagCompraCadastroComponent } from './configuracoes/pages/config-suprimentos/tag-compra-cadastro/tag-compra-cadastro.component';
import { LocalizacaoEstoqueComponent } from './configuracoes/pages/config-suprimentos/localizacao-estoque/localizacao-estoque.component';
import { LocalizacaoEstoqueCadastroComponent } from './configuracoes/pages/config-suprimentos/localizacao-estoque-cadastro/localizacao-estoque-cadastro.component';
import { TagsProducaoComponent } from './configuracoes/pages/config-suprimentos/tags-producao/tags-producao.component';
import { TagProducaoCadastroComponent } from './configuracoes/pages/config-suprimentos/tag-producao-cadastro/tag-producao-cadastro.component';
import { TagsServicoTomadoComponent } from './configuracoes/pages/config-suprimentos/tags-servico-tomado/tags-servico-tomado.component';
import { TagServicoTomadoCadastroComponent } from './configuracoes/pages/config-suprimentos/tag-servico-tomado-cadastro/tag-servico-tomado-cadastro.component';
import { TagsNFeEntradaComponent } from './configuracoes/pages/config-suprimentos/tags-nfe-entrada/tags-nfe-entrada.component';
import { TagNFeEntradaCadastroComponent } from './configuracoes/pages/config-suprimentos/tag-nfe-entrada-cadastro/tag-nfe-entrada-cadastro.component';
import { SuprimentosHomeComponent } from './suprimentos/pages/suprimentos-home/suprimentos-home.component';
import { ControleEstoqueComponent } from './suprimentos/pages/controle-estoque/controle-estoque.component';
import { NotaFiscalEntradaListaComponent } from './suprimentos/pages/nota-fiscal-entrada-lista/nota-fiscal-entrada-lista.component';
import { ControleEstoqueDetalheComponent } from './suprimentos/pages/controle-estoque-detalhe/controle-estoque-detalhe.component';
import { InventarioListaComponent } from './suprimentos/pages/inventario-lista/inventario-lista.component';
import { InventarioDigitacaoComponent } from './suprimentos/pages/inventario-digitacao/inventario-digitacao.component';
import { InventarioFiltrarProdutosComponent } from './suprimentos/pages/inventario-filtrar-produtos/inventario-filtrar-produtos.component';
import { InventarioImportarPlanilhaComponent } from './suprimentos/pages/inventario-importar-planilha/inventario-importar-planilha.component';
import { InventarioImportarColetorComponent } from './suprimentos/pages/inventario-importar-coletor/inventario-importar-coletor.component';
import { TransferenciaEstoqueListaComponent } from './suprimentos/pages/transferencia-estoque-lista/transferencia-estoque-lista.component';
import { FciListaComponent } from './suprimentos/pages/fci-lista/fci-lista.component';
import { FciCadastroComponent } from './suprimentos/pages/fci-cadastro/fci-cadastro.component';
import { TransferenciaEstoqueCadastroComponent } from './suprimentos/pages/transferencia-estoque/transferencia-estoque-cadastro.component';
import { ProcessoComprasComponent } from './suprimentos/pages/processo-compras/processo-compras.component';
import { ServicoTomadoListaComponent } from './suprimentos/pages/servico-tomado-lista/servico-tomado-lista.component';
import { ServicoTomadoCadastroComponent } from './suprimentos/pages/servico-tomado-cadastro/servico-tomado-cadastro.component';
import { OrdemProducaoListaComponent } from './suprimentos/pages/ordem-producao-lista/ordem-producao-lista.component';
import { OrdemProducaoCadastroComponent } from './suprimentos/pages/ordem-producao-cadastro/ordem-producao-cadastro.component';
import { OrdemProducaoDetalheComponent } from './suprimentos/pages/ordem-producao-detalhe/ordem-producao-detalhe.component';
import { NaturezaOperacaoListaComponent } from './configuracoes/pages/config-notas-fiscais/natureza-operacao-lista/natureza-operacao-lista.component';
import { NaturezaOperacaoCadastroComponent } from './configuracoes/pages/config-notas-fiscais/natureza-operacao-cadastro/natureza-operacao-cadastro.component';
import { TabelaDifalListaComponent } from './configuracoes/pages/config-notas-fiscais/tabela-difal-lista/tabela-difal-lista.component';
import { ConfigTiposTributariosComponent } from './configuracoes/pages/config-cadastros/config-tipos-tributarios/config-tipos-tributarios.component';
import { TipoTributarioCadastroComponent } from './configuracoes/pages/config-cadastros/tipo-tributario-cadastro/tipo-tributario-cadastro.component';
import { TabelaDifalCadastroComponent } from './configuracoes/pages/config-notas-fiscais/tabela-difal-cadastro/tabela-difal-cadastro.component';
import { RegraTributariaListaComponent } from './configuracoes/pages/config-reforma-tributaria/regra-tributaria-lista/regra-tributaria-lista.component';
import { RegraTributariaCadastroComponent } from './configuracoes/pages/config-reforma-tributaria/regra-tributaria-cadastro/regra-tributaria-cadastro.component';
import { ConfigReformaTributariaComponent } from './configuracoes/pages/config-reforma-tributaria/config-reforma-tributaria.component';
import { ReajustePrecosListaComponent } from './cadastros/pages/reajuste-precos-lista/reajuste-precos-lista.component';
import { ReajustePrecosCadastroComponent } from './cadastros/pages/reajuste-precos-cadastro/reajuste-precos-cadastro.component';
import { ReajustePrecosVisualizarComponent } from './cadastros/pages/reajuste-precos-visualizar/reajuste-precos-visualizar.component';
import { CrmOportunidadesComponent } from './vendas/pages/crm-oportunidades/crm-oportunidades.component';
import { ProcessoVendaComponent } from './vendas/pages/processo-venda/processo-venda.component';
import { VendaDocumentoComponent } from './vendas/pages/venda-documento/venda-documento.component';
import { NotaFiscalSaidaListaComponent } from './vendas/pages/nota-fiscal-saida-lista/nota-fiscal-saida-lista.component';

// prettier-ignore
export const routes: Routes = [
    { path: '', component: AuthComponent, pathMatch: 'full' },
    {
        path: 'cobranca/:guid',
        loadComponent: () => import('./cobranca/pages/cobranca-publica/cobranca-publica.component').then(m => m.CobrancaPublicaComponent)
    },
    {
        path: 'home',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./home/pages/home-ia/home-ia.component').then(m => m.HomeIaComponent),
            },
            // Home antiga (grid de módulos), preservada para rollback/consulta.
            { path: 'modulos', component: HomeComponent },
            {
                path: 'chat',
                loadComponent: () => import('./home/pages/home-ia-chat/home-ia-chat.component').then(m => m.HomeIaChatComponent),
            },
            {
                path: 'chat/:idConversa',
                loadComponent: () => import('./home/pages/home-ia-chat/home-ia-chat.component').then(m => m.HomeIaChatComponent),
            },
            {
                path: 'ferramentas',
                component: FerramentasComponent,
                data: {
                    modulo: ModuloEnum.Home
                }
            },
            {
                path: 'ferramentas/minhas-exportacoes',
                component: MinhasExportacoesComponent,
                data: {
                    modulo: ModuloEnum.Home
                }
            },
            {
                path: 'ferramentas/automacao-extracao-dados', component: AutomacaoExtracaoDadosListaComponent, data: {}
            },
            {
                path: 'ferramentas/automacao-extracao-dados/cadastrar', component: AutomacaoExtracaoDadosCadastroComponent, data: {}
            },
            {
                path: 'ferramentas/inteligencia-artificial-whatsapp', component: WhatsappCadastroComponent, data: {}
            },
            {
                path: 'meu-usuario',
                loadComponent: () => import('./home/pages/meu-usuario/meu-usuario.component').then(m => m.MeuUsuarioComponent),
            }
        ]
    },
    {
        path: 'auth',
        children: [
            { path: 'senha-recuperar', component: SenhaRecuperarComponent },
            { path: 'senha-alterar/:token', component: SenhaAlterarComponent },
        ]
    },
    // Documentação pública da API de Integração (sem AuthGuard, fora do shell autenticado).
    {
        path: 'documentacao-publica',
        loadComponent: () => import('./integration/pages/documentacao-publica/documentacao-publica.component').then(m => m.DocumentacaoPublicaComponent)
    },
    // Portal público do fornecedor (sem AuthGuard, fora do shell autenticado).
    { path: 'portal/cotacao/:token', component: PortalCotacaoComponent },
    { path: 'portal/pedido/:token', component: PortalPedidoComponent },
    { path: 'portal/venda/:token', component: PortalVendaComponent },
    {
        path: 'configuracoes',
        children: [
            {
                path: '', component: ConfiguracoesHomeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'gerais',
                loadComponent: () => import('./configuracoes/pages/config-gerais/config-gerais.component').then(m => m.ConfigGeraisComponent),
                canActivate: [AuthGuard],
                data: { modulo: ModuloEnum.Configuracoes }
            },
            {
                path: 'gerais/etiquetas',
                loadComponent: () => import('./configuracoes/pages/config-gerais/etiqueta-lista/etiqueta-lista.component').then(m => m.EtiquetaListaComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'gerais/casas-decimais',
                loadComponent: () => import('./configuracoes/pages/config-gerais/casas-decimais/casas-decimais.component').then(m => m.CasasDecimaisComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'gerais/multiempresa',
                loadComponent: () => import('./configuracoes/pages/config-gerais/multiempresa-lista/multiempresa-lista.component').then(m => m.MultiempresaListaComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'gerais/multiempresa/configurar/:idEmpresa',
                loadComponent: () => import('./configuracoes/pages/config-gerais/multiempresa-configuracao/multiempresa-configuracao.component').then(m => m.MultiempresaConfiguracaoComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'gerais/etiquetas/cadastrar',
                loadComponent: () => import('./configuracoes/pages/config-gerais/etiqueta-cadastro/etiqueta-cadastro.component').then(m => m.EtiquetaCadastroComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'gerais/etiquetas/cadastrar/:idConfiguracaoEtiqueta',
                loadComponent: () => import('./configuracoes/pages/config-gerais/etiqueta-cadastro/etiqueta-cadastro.component').then(m => m.EtiquetaCadastroComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },


            {
                path: 'usuario', component: UsuarioListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'usuario/cadastrar', component: UsuarioCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'perfil', component: PerfilListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'perfil/cadastrar', component: PerfilCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },

            {
                path: 'empresa', component: EmpresaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais', component: ConfigNotasFiscaisComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/gerais', component: ConfigGeralNotasFiscaisComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/nfe', component: ConfigNFeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/nfce', component: ConfigNFCeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/busca-nfe-sefaz', component: BuscaNFeSefazComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/tabela-anp', component: TabelaAnpComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/certificado', component: CertificadoECNPJComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/emissor', component: EmissorListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/emissor/cadastrar', component: EmissorCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/natureza-operacao', component: NaturezaOperacaoListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/tabela-difal', component: TabelaDifalListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/tabela-difal/cadastrar/:id', component: TabelaDifalCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/natureza-operacao/cadastrar', component: NaturezaOperacaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'notas-fiscais/natureza-operacao/cadastrar/:idNaturezaOperacao', component: NaturezaOperacaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'reforma-tributaria', component: ConfigReformaTributariaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'reforma-tributaria/regra-padrao', component: RegraTributariaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes, modoPadrao: true
                }
            },
            {
                path: 'reforma-tributaria/regras', component: RegraTributariaListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'reforma-tributaria/regras/cadastrar', component: RegraTributariaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'reforma-tributaria/regras/cadastrar/:idRegraTributaria', component: RegraTributariaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas',
                component: ConfigFinancasComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos',
                component: ConfigSuprimentosComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/config-estoque',
                component: ConfigEstoqueComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/config-fci',
                component: ConfigFciComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/formulas-custo-venda',
                component: FormulasCustoVendaComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/config-kanban-compras',
                component: ConfigKanbanComprasComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/automacoes',
                component: AutomacoesComprasComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/comunicacao-cotacao',
                component: ComunicacaoCotacaoComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/comunicacao-pedido',
                component: ComunicacaoPedidoComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/localizacao-estoque', component: LocalizacaoEstoqueComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/localizacao-estoque/cadastrar', component: LocalizacaoEstoqueCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-compra', component: TagsCompraComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-compra/cadastrar', component: TagCompraCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-producao', component: TagsProducaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-producao/cadastrar', component: TagProducaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-servico-tomado', component: TagsServicoTomadoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-servico-tomado/cadastrar', component: TagServicoTomadoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-nfe-entrada', component: TagsNFeEntradaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'suprimentos/tags-nfe-entrada/cadastrar', component: TagNFeEntradaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/contas-financeiras',
                loadComponent: () => import('./configuracoes/pages/config-financas/config-contas-financeiras/contas-financeiras.component').then(m => m.ContasFinanceirasComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/contas-financeiras/cadastrar',
                loadComponent: () => import('./configuracoes/pages/config-financas/conta-financeira-cadastro/conta-financeira-cadastro.component').then(m => m.ContaFinanceiraCadastroComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/contas-financeiras/cadastrar/:idContaFinanceira',
                loadComponent: () => import('./configuracoes/pages/config-financas/conta-financeira-cadastro/conta-financeira-cadastro.component').then(m => m.ContaFinanceiraCadastroComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros', component: ConfigCadastrosComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/campos-obrigatorios', component: CamposObrigatoriosCadastrosComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/pessoas', component: ConfigPessoaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/produtos', component: ConfigProdutoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/tags', component: ConfigTagsComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/tags/cadastrar', component: TagCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/tags/cadastrar/:idTag', component: TagCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/marcas', component: ConfigMarcasComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/marcas/cadastrar', component: MarcaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/marcas/cadastrar/:idMarca', component: MarcaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/unidades-medida', component: ConfigUnidadesMedidaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/unidades-medida/cadastrar', component: UnidadeMedidaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/unidades-medida/cadastrar/:idUnidadeMedida', component: UnidadeMedidaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/variacoes', component: ConfigVariacoesComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/variacoes/cadastrar', component: VariacaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/variacoes/cadastrar/:idVariacao', component: VariacaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/atributos-produtos', component: ConfigAtributosProdutosComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/atributos-produtos/cadastrar', component: AtributoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/atributos-produtos/cadastrar/:idAtributo', component: AtributoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/lista-precos', component: ConfigListaPrecoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/lista-precos/cadastrar', component: ListaPrecoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/tipos-tributarios', component: ConfigTiposTributariosComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/tipos-tributarios/cadastrar', component: TipoTributarioCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/tipos-tributarios/cadastrar/:idTipoTributario', component: TipoTributarioCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/linha-produtos', component: ConfigLinhaProdutosComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/linha-produtos/cadastrar', component: LinhaProdutoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'cadastros/linha-produtos/cadastrar/:idLinhaProduto', component: LinhaProdutoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas', component: ConfigFinancasComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/contas-pagar', component: ConfigContasPagarComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/gerais', component: ConfigGeralFinancasComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/contas-receber', component: ConfigContasReceberComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/categorias-padrao', component: ConfigCategoriaFinanceiraPadraoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/campos-obrigatorios', component: CamposObrigatoriosFinancasComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/formas-pagamento', component: FormasPagamentoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/formas-recebimento', component: FormasRecebimentoListComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/intermediador-pagamento', component: IntermediadorPagamentoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/intermediador-pagamento/cadastrar', component: IntermediadorPagamentoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/intermediador-pagamento/cadastrar/:idIntermediadorPagamento', component: IntermediadorPagamentoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/formas-recebimento/cadastrar', component: FormaRecebimentoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/formas-recebimento/cadastrar/:idFormaRecebimento', component: FormaRecebimentoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/condicoes-pagamento', component: CondicoesPagamentoListComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/condicoes-pagamento/cadastrar', component: CondicaoPagamentoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/condicoes-pagamento/cadastrar/:idCondicaoPagamento', component: CondicaoPagamentoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/tags-movimentacao', component: TagsMovimentacaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/categorias', component: CategoriaFinanceiraListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/categorias/cadastrar', component: CategoriaFinanceiraCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/tags-movimentacao/cadastrar', component: TagMovimentacaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/centros-custo', component: CentrosCustoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/centros-custo/cadastrar', component: CentroCustoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/centros-custo/cadastrar/:idCentroCusto', component: CentroCustoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/rateios-centro-custo', component: RateiosCentroCustoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/rateios-centro-custo/cadastrar', component: RateioCentroCustoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/rateios-centro-custo/cadastrar/:idRateioCentroCusto', component: RateioCentroCustoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/tags-contas-pagar', component: TagsContasPagarComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/tags-contas-pagar/cadastrar', component: TagContasPagarCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/tags-contas-receber', component: TagsContasReceberComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/tags-contas-receber/cadastrar', component: TagContasReceberCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'financas/envio-documentos',
                loadComponent: () => import('./configuracoes/pages/config-financas/envio-documentos/envio-documentos.component').then(m => m.EnvioDocumentosComponent),
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas', component: ConfigVendasComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/gerais', component: ConfigGeralVendasComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/automacoes', component: AutomacoesVendaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-venda', component: TagsVendaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-venda/cadastrar', component: TagVendaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-crm', component: TagsCrmComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-crm/cadastrar', component: TagCrmCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-devolucao-venda', component: TagsDevolucaoVendaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-devolucao-venda/cadastrar', component: TagDevolucaoVendaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-separacao', component: TagsSeparacaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-separacao/cadastrar', component: TagSeparacaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-nfe-saida', component: TagsNFeSaidaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/tags-nfe-saida/cadastrar', component: TagNFeSaidaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/devolucoes', component: DevolucoesVendaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/configuracao-pdv', component: ConfigPdvComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/orcamento', component: ConfigOrcamentoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            // Rota antiga da tela, mantida como redirect: a rotina se chamava "Proposta Comercial"
            // e links salvos por usuários ainda apontam para cá.
            {
                path: 'vendas/proposta-comercial', redirectTo: 'vendas/orcamento', pathMatch: 'full'
            },
            {
                path: 'vendas/pedido-venda', component: ConfigPedidoVendaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/kanban-oportunidades', component: ConfigKanbanOportunidadesComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/kanban', component: ConfigKanbanComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/motivos-transicao', component: MotivosTransicaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/motivos-transicao/cadastrar', component: MotivoTransicaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/motivos-transicao/cadastrar/:idMotivoTransicao', component: MotivoTransicaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/separacao', component: ConfigSeparacaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/expedicao', component: ConfigExpedicaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/formas-envio', component: FormasEnvioComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/formas-envio/cadastrar', component: FormaEnvioCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'vendas/formas-envio/cadastrar/:idFormaEnvio', component: FormaEnvioCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos', component: ConfigServicosComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/gerais', component: ConfigGeralOrdemServicoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/kanban', component: ConfigKanbanOrdemServicoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/motivos-transicao', component: MotivosTransicaoOrdemServicoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/motivos-transicao/cadastrar', component: MotivoTransicaoOrdemServicoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/automacoes', component: AutomacoesOrdemServicoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/campos-adicionais', component: CamposAdicionaisComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/campos-adicionais/cadastrar', component: CampoAdicionalCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/tags-ordem-servico', component: TagsOrdemServicoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/tags-ordem-servico/cadastrar', component: TagOrdemServicoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/tags-contrato', component: TagsContratoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/tags-contrato/cadastrar', component: TagContratoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/envio-documentos', component: EnvioDocumentosServicoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/cnaes', component: CnaesComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            },
            {
                path: 'servicos/cnaes/cadastrar', component: CnaeCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Configuracoes
                }
            }
        ]
    },
    {
        path: 'integracao',
        children: [
            {
                path: '', component: IntegracaoHomeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'chave-acesso', component: ChaveAcessoListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'chave-acesso/cadastrar', component: ChaveAcessoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'logs', component: LogIntegracaoListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'logs/detalhe', component: LogIntegracaoDetalhesComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'integracao-zoppy', component: IntegracaoZoppyComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'resulth-local-connect', component: ResulthLocalConnectComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'resulth-scanntech', component: ResulthScanntechListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'resulth-scanntech/configurar', component: ConfigurarResulthScanntechComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'resulth-scanntech/relatorio', component: RelatorioVendasResulthScanntechComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
            {
                path: 'resulth-scanntech/dados-integracao', component: DadosIntegracaoScanntechComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Integracao
                }
            },
        ]
    },
    {
        path: 'notas-fiscais',
        children: [
            {
                path: '', component: NotasFiscaisHomeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'painel-contador/nfe/detalhe-nota/:idNFeEmitido', component: DetalheNFeEmitidoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'painel-contador/nfce/detalhe-nota/:idNFCeEmitido', component: DetalheNFCeEmitidoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'painel-contador/nfse/detalhe-nota/:idNFSeEmitido', component: DetalheNFSeEmitidoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'painel-contador', component: PainelContadorComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'notas-recebidas/nfe/detalhe-nota/:idNFeRecebido', component: DetalheNFeRecebidoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'notas-recebidas/cte/detalhe-nota/:idCTeRecebido', component: DetalheCTeRecebidoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'notas-recebidas', component: PainelNotaRecebidaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            },
            {
                path: 'nfces-em-contingencia', component: NFCesEmContingenciaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.NotasFiscais
                }
            }
        ]
    },
    {
        path: 'financas',
        children: [
            {
                path: '', component: FinancasHomeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'extrato-movimentacoes', component: ExtratoMovimentacoesComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'lancamentos/cadastrar', component: LancamentoCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'conciliacao-bancaria', component: ConciliacaoBancariaContasComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'conciliacao-bancaria/lancamentos/:idContaFinanceira',
                component: ConciliacaoBancariaLancamentosComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'conciliacao-bancaria/ignorados/:idContaFinanceira',
                component: ConciliacaoBancariaIgnoradosComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'conciliacao-bancaria/conciliados/:idContaFinanceira',
                component: ConciliacaoBancariaConciliadosComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'conciliacao-bancaria/cartao/lancamentos/:idContaFinanceira',
                component: ConciliacaoCartaoLancamentosComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'conciliacao-bancaria/cartao/conciliados/:idContaFinanceira',
                component: ConciliacaoCartaoConciliadosComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'contas-pagar', component: ContasPagarListaComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'lancamentos/editar/:id', component: LancamentoCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'contas-pagar/cadastrar',
                component: ContasPagarCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'transferencias/cadastrar', component: TransferenciaCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'contas-pagar/parcela/:idContasPagarParcela',
                component: ContasPagarParcelaCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'transferencias/editar/:id', component: TransferenciaCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'contas-receber', component: ContasReceberListaComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'contas-receber/cadastrar', component: ContasReceberCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'contas-receber/cadastrar/:id', component: ContasReceberCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'contas-receber/parcela/:idContasReceberParcela', component: ContasReceberParcelaCadastroComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'relatorios', component: RelatoriosFinancasComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'relatorios/entradas-saidas-cliente', component: RelatorioEntradasSaidasClienteComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'relatorios/entradas-saidas-categoria', component: RelatorioEntradasSaidasCategoriaComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'relatorios/contas-a-pagar', component: RelatorioContasPagarComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'relatorios/contas-a-receber', component: RelatorioContasReceberComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
            {
                path: 'relatorios/fluxo-de-caixa', component: RelatorioFluxoCaixaComponent,
                canActivate: [AuthGuard],
                data: {
                    modulo: ModuloEnum.Financas
                }
            },
        ]
    },
    {
        path: 'vendas',
        children: [
            {
                path: 'crm', component: CrmOportunidadesComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                }
            },
            // O path tem que casar exatamente com funcionalidade.uri (/vendas/processo-venda),
            // senao o menu nao marca o item como ativo.
            {
                path: 'processo-venda', component: ProcessoVendaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                }
            },
            // Documento da venda (documento e documento/:id). Documento novo recebe o tipo em ?tipo=
            // (ele decide a tela inteira) e, na clonagem, a venda de origem em ?origem=.
            {
                path: 'processo-venda/documento', component: VendaDocumentoComponent,
                canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                }
            },
            {
                path: 'processo-venda/documento/:idVenda', component: VendaDocumentoComponent,
                canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                }
            },
            // Documento e visualização da NF-e de saída (documento, documento/:id e documento/:id/visualizar).
            {
                path: 'nota-fiscal-saida/documento', canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                },
                loadComponent: () => import('./vendas/pages/nota-fiscal-saida-documento/nota-fiscal-saida-documento.component').then(m => m.NotaFiscalSaidaDocumentoComponent)
            },
            {
                path: 'nota-fiscal-saida/documento/:idNFeSaida/visualizar', canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                },
                loadComponent: () => import('./vendas/pages/nota-fiscal-saida-visualizacao/nota-fiscal-saida-visualizacao.component').then(m => m.NotaFiscalSaidaVisualizacaoComponent)
            },
            {
                path: 'nota-fiscal-saida/documento/:idNFeSaida', canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                },
                loadComponent: () => import('./vendas/pages/nota-fiscal-saida-documento/nota-fiscal-saida-documento.component').then(m => m.NotaFiscalSaidaDocumentoComponent)
            },
            // O path tem que casar exatamente com funcionalidade.uri (/vendas/nota-fiscal-saida).
            {
                path: 'nota-fiscal-saida', component: NotaFiscalSaidaListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Vendas
                }
            }
        ]
    },
    {
        path: 'suprimentos',
        children: [
            {
                path: '', component: SuprimentosHomeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'controle-estoque', component: ControleEstoqueComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'nota-fiscal-entrada', component: NotaFiscalEntradaListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'nota-fiscal-entrada/documento', canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                },
                loadComponent: () => import('./suprimentos/pages/nota-fiscal-entrada-documento/nota-fiscal-entrada-documento.component').then(m => m.NotaFiscalEntradaDocumentoComponent)
            },
            {
                path: 'nota-fiscal-entrada/documento/:idNFeEntrada', canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                },
                loadComponent: () => import('./suprimentos/pages/nota-fiscal-entrada-documento/nota-fiscal-entrada-documento.component').then(m => m.NotaFiscalEntradaDocumentoComponent)
            },
            {
                path: 'controle-estoque-detalhe/:idProduto', component: ControleEstoqueDetalheComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'inventario', component: InventarioListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'inventario/filtrar-produtos', component: InventarioFiltrarProdutosComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'inventario/importar-planilha', component: InventarioImportarPlanilhaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'inventario/importar-coletor', component: InventarioImportarColetorComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'inventario/novo', component: InventarioDigitacaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'inventario/:idInventario', component: InventarioDigitacaoComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'transferencia-estoque', component: TransferenciaEstoqueListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            // Caminho no SINGULAR de propósito: tem que casar com funcionalidade.uri
            // (/suprimentos/ordem-producao), senão o menu não marca o item como ativo.
            {
                path: 'ordem-producao', component: OrdemProducaoListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'ordem-producao/cadastrar', component: OrdemProducaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'ordem-producao/:idOrdemProducao/editar', component: OrdemProducaoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'ordem-producao/:idOrdemProducao/visualizar', component: OrdemProducaoDetalheComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'fci', component: FciListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'fci/cadastrar', component: FciCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'fci/editar/:id', component: FciCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'transferencia-estoque/cadastrar', component: TransferenciaEstoqueCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'transferencia-estoque/editar/:id', component: TransferenciaEstoqueCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'processo-compras', component: ProcessoComprasComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'servicos-tomados', component: ServicoTomadoListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'servicos-tomados/incluir', component: ServicoTomadoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            },
            {
                path: 'servicos-tomados/editar/:id', component: ServicoTomadoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Suprimentos
                }
            }
        ]
    },
    {
        path: 'cadastros',
        children: [
            {
                path: '', component: CadastrosHomeComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'vendedores', component: VendedorListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'vendedor/cadastrar', component: VendedorCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'pessoas', component: PessoaListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'produtos', component: ProdutoListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'produtos/cadastrar', component: ProdutoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'reajuste-precos',
                component: ReajustePrecosListaComponent,
                canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'reajuste-precos/novo',
                component: ReajustePrecosCadastroComponent,
                canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'reajuste-precos/:id',
                component: ReajustePrecosVisualizarComponent,
                canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'pessoas/cadastrar', component: PessoaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'embalagens', component: EmbalagemListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'embalagem/cadastrar', component: EmbalagemCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'embalagem/cadastrar/:idEmbalagem', component: EmbalagemCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'categorias', component: CategoriaListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'categoria/cadastrar', component: CategoriaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'categoria/cadastrar/:idCategoria', component: CategoriaCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'servicos', component: ServicoListaComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'servicos/cadastrar', component: ServicoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            },
            {
                path: 'servicos/cadastrar/:idServico', component: ServicoCadastroComponent, canActivate: [AuthGuard], data: {
                    modulo: ModuloEnum.Cadastros
                }
            }
        ]
    }
];
